// 그리드에 그릴 이미지 — 서버가 만든 WebP 썸네일(thumbUrls, functions/thumbs.js)
// 이 있으면 그걸, 아직 없으면 원본. 썸네일은 cover 기준 768×960 이상이라
// 태블릿 2열(@2x 734×918)까지 원본과 같은 선명도다. 상세 화면·다운로드·
// before/after 는 계속 원본(generatedImageUrls)을 쓴다.
export function gridImage(design, i = 0) {
  return design?.thumbUrls?.[i] || design?.generatedImageUrls?.[i] || null;
}

// 썸네일이 깨지면(재생성 직후 지워진 옛 썸네일 등) 원본으로 한 번 갈아끼운다.
export function fallbackToFull(design, i = 0) {
  return (e) => {
    const full = design?.generatedImageUrls?.[i];
    if (full && e.currentTarget.src !== full) e.currentTarget.src = full;
  };
}
